<template>
  <h2 class="m-2 p-2 border-b-2 border-gray-500 text-left text-2xl font-bold mb-5 text-gray-800 flex">
    404
  </h2>
</template>
